(() => {
 if (window.seprioHomeCartInitialized) return;
 window.seprioHomeCartInitialized = true;
 async function addSelectedProduct(event, form) {
  if (!form) return;
  event.preventDefault();
  event.stopPropagation();
  if (form.dataset.busy === 'true') return;
  const button = form.querySelector('button');
  const status = form.querySelector('.sh-cart-status');
  form.dataset.busy = 'true'; button.disabled = true; form.setAttribute('aria-busy', 'true');
  status.textContent = status.dataset.loading;
  let added = false;
  try {
   const data = new FormData(form);
   data.append('sections', 'side-cart');
   data.append('sections_url', location.pathname);
   const root = window.Shopify?.routes?.root || '/';
   const response = await fetch(root + 'cart/add.js', {method:'POST',body:data,headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'}});
   const result = await response.json();
   if (!response.ok || result.status) { status.textContent = result.description || status.dataset.error; return; }
   added = true; status.textContent = status.dataset.success;
   if (window.ajaxCart?.load && result.sections?.['side-cart']) window.ajaxCart.load(result);
   else location.assign(root + 'cart');
  } catch (error) {
   status.textContent = added ? status.dataset.success : status.dataset.uncertain;
   const link = document.createElement('a');
   link.href = (window.Shopify?.routes?.root || '/') + 'cart';
   link.textContent = document.documentElement.lang.startsWith('nl') ? ' Bekijk je winkelwagen.' : ' View your cart.';
   status.append(link);
  } finally { form.dataset.busy = 'false'; button.disabled = false; form.removeAttribute('aria-busy'); }
 }
 // Capture only our own cards before the theme's generic product-form listeners.
 document.addEventListener('submit', event => {
  addSelectedProduct(event, event.target.closest('.sh-cart-form'));
 }, true);
 document.addEventListener('click', event => {
  const button = event.target.closest('.sh-cart-form button[type="submit"]');
  if (button) addSelectedProduct(event, button.form);
 }, true);
})();